<template>
    <NuxtPage></NuxtPage>
    <helper v-if="!['Home', 'Chatagent'].includes(($route.meta.route || '') as string)" />
</template>

<script lang="ts" setup>
//* 公共组件
import { Helper } from "@/components/complete";
//* i18n配置
import { i18nOption } from "@/app/i18n";
//* 公共工具函数
import { Formats } from "@/assets/js";

//* Vue插件引入
const i18n = useI18n();
const route = useRoute();
//* store数据
const user = useUserStore();
//* cookie数据
const token = useCookie("X-Token", { maxAge: 1296000 });

//* 获取网站TDK配置
const setting = await api.server("Setting", "/api/v1/common/setting", {
    data: { url: route.path.replace(/^\/zh/, "") },
});

//* 初始化全局文案翻译
i18n.locale.value = (route.meta?.routeLanguage || i18nOption.locale) as string;

//* 监听Token数据变化
const cookie: { stop?: () => void } = {};

//* 组件卸载时, 注销侦听器
onBeforeUnmount(() => cookie.stop?.());
//* 组件挂载时, 注册侦听器
onMounted(() => {
    //* 初始化Token数据
    token.value = Formats.query(route.query.access_token) || token.value;
    //* 移除URL中的Token数据
    if (route.query.access_token) {
        const url = new URL(window.location.href);
        url.searchParams.delete("access_token");
        history.replaceState({}, "", url.pathname + url.search);
    }

    //* 注册路由中间件
    cookie.stop = watch(token, async () => await user.init());
});

//* 更新网站TDK
useHead({
    title: setting.value?.title || "罕见病数据库",
    meta: [
        { name: "keywords", content: setting.value?.keyword || "罕见病数据库" },
        { name: "description", content: setting.value?.description || "罕见病数据库" },
    ],
});
</script>
